import React from "react";

import heroFacebook from "../assets/email-assets/facebook.jpg";
import heroInstagram from "../assets/email-assets/instagram.jpg";
import heroTikTok from "../assets/email-assets/tiktok.jpg";
import heroYouTube from "../assets/email-assets/youtube.jpg";
import heroGoogle from "../assets/email-assets/google.jpg";
import heroOLV from "../assets/email-assets/video.jpg";
import heroDisplay from "../assets/email-assets/display.jpg";
import heroDooh from "../assets/email-assets/dooh.gif";
import heroCinema from "../assets/email-assets/PurpleFilmIcon.jpg";
import heroX from "../assets/email-assets/x.jpg";
import heroMobile from "../assets/mobile.jpg";

const BULLET_PREFIX_RE =
  /^\s*(?:🟣|✅|☑️|☑|✔️|✔|✓|■|▪|●|◦|◉|◆|♦|▶️|▶|•|\*|-|–|—)\s+/;
const ORPHAN_BULLET_RE =
  /^\s*(?:🟣|✅|☑️|☑|✔️|✔|✓|■|▪|●|◦|◉|◆|♦|▶️|▶|•|\*|-|–|—)\s*$/;

const SECTION_ICON_PREFIX_RE =
  /^\s*(?:(?:[▶►▷▸](?:\uFE0F|\uFE0E)?)|📘|📸|🎵|🐦|🏙️|🏙|📺|🎬|💻|🎞️|🎞|📈|🎯|🧭|🚀|🔍|🧠|🔎)\s+/;

const STANDARD_BULLET_MARKER = "●";
const STRUCTURED_PLANNER_LABEL_RE =
  /^(primary role|rationale|objective|notes|recommendation|strategic takeaway|final summary|messaging hooks?|ctas?|set frequency caps?|fail[-\s]?fast|guardrails?|optimization logic(?:\s*&\s*guardrails)?|optimization approach|bidding approach|audience strategy|creative format|creative formats|creative considerations|testing plan|measurement plan)$/i;
const SAFE_KEY_VALUE_LABEL_RE =
  /^(?:[A-Za-z][A-Za-z'&/+()-]*)(?:\s+[A-Za-z][A-Za-z'&/+()-]*){0,5}$/;

const CHANNEL_HERO_MAP = {
  facebook: { key: "facebook", label: "Facebook", img: heroFacebook },
  instagram: { key: "instagram", label: "Instagram", img: heroInstagram },
  tiktok: { key: "tiktok", label: "TikTok", img: heroTikTok },
  youtube: { key: "youtube", label: "YouTube", img: heroYouTube },
  "google search": { key: "google_search", label: "Google Search", img: heroGoogle },
  search: { key: "google_search", label: "Google Search", img: heroGoogle },
  olv: { key: "video", label: "Online Video (OLV)", img: heroOLV },
  "online video": { key: "video", label: "Online Video (OLV)", img: heroOLV },
  display: { key: "display", label: "Display", img: heroDisplay },
  mobile: { key: "mobile", label: "Mobile", img: heroMobile },
  "mobile display": { key: "mobile", label: "Mobile", img: heroMobile },
  "mobile ads": { key: "mobile", label: "Mobile", img: heroMobile },
  "in-app mobile": { key: "mobile", label: "Mobile", img: heroMobile },
  "mobile/in-app": { key: "mobile", label: "Mobile", img: heroMobile },
  dooh: { key: "dooh", label: "Digital-Out-of-Home (DOOH)", img: heroDooh },
  "digital out of home": { key: "dooh", label: "Digital-Out-of-Home (DOOH)", img: heroDooh },
  "digital out-of-home": { key: "dooh", label: "Digital-Out-of-Home (DOOH)", img: heroDooh },
  ooh: { key: "dooh", label: "Digital-Out-of-Home (DOOH)", img: heroDooh },
  cinema: { key: "cinema", label: "Cinema (Theatrical)", img: heroCinema },
  theatrical: { key: "cinema", label: "Cinema (Theatrical)", img: heroCinema },
  x: { key: "x", label: "X", img: heroX },
  "x (twitter)": { key: "x", label: "X (Twitter)", img: heroX },
};

const EXPLICIT_CHANNEL_HERO_BY_TRIGGER = {
  "📘": CHANNEL_HERO_MAP.facebook,
  "📸": CHANNEL_HERO_MAP.instagram,
  "🎵": CHANNEL_HERO_MAP.tiktok,
  "📺": CHANNEL_HERO_MAP.youtube,
  "🔎": CHANNEL_HERO_MAP["google search"],
  "🎬": CHANNEL_HERO_MAP.olv,
  "💻": CHANNEL_HERO_MAP.display,
  "🎞️": CHANNEL_HERO_MAP.cinema,
  "🐦": CHANNEL_HERO_MAP.x,
};

const clampText = (value, max = 26000) => {
  if (!value) return value;
  const text = String(value);
  return text.length > max ? `${text.slice(0, max)}\n…(truncated)` : text;
};

const normalizeText = (value) => {
  if (value == null) return "";
  if (Array.isArray(value)) return value.filter(Boolean).join(", ");
  if (typeof value === "object") {
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
  return String(value);
};

const stripEmojiLike = (input) => {
  const source = String(input || "");
  try {
    return source
      .replace(/\p{Extended_Pictographic}+/gu, "")
      .replace(/\uFE0F/gu, "")
      .replace(/\uFE0E/gu, "")
      .replace(/\u200D/gu, "")
      .replace(/[☑✔✓■▪●◦◉◆♦▶►▷▸]/g, "")
      .trim();
  } catch {
    return source
      .replace(
        /[🔍🟣✅▶️🧠📘📸🎵🐦🏙️🏙📺🎬💻🎞️🎞📈🎯🧭🚀🔎]/g,
        ""
      )
      .replace(/[☑✔✓■▪●◦◉◆♦▶►▷▸]/g, "")
      .trim();
  }
};

const splitSmartLines = (raw) => {
  const text = String(raw || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  if (text.includes("\n")) return text.split("\n");

  return text
    .replace(/\s+(?=(_{12,}|—{6,}|-{6,}))/g, "\n")
    .replace(
      /\s+(?=(?:🟣|✅|☑️|☑|✔️|✔|✓|■|▪|●|◦|◉|◆|♦|•|\*|-|–|—)\s+)/g,
      "\n"
    )
    .replace(
      /\s+(?=(?:▶️|▶|📘|📸|🎵|🐦|🏙️|🏙|📺|🎬|💻|🎞️|🎞|📈|🎯|🧭|🚀|🔍|🧠|🔎)\s+)/g,
      "\n"
    )
    .split("\n");
};

const stripPrefixSymbols = (line) =>
  String(line || "")
    .replace(BULLET_PREFIX_RE, "")
    .replace(SECTION_ICON_PREFIX_RE, "")
    .trim();

const isDividerLine = (line) => /^[\s_—-]{12,}$/.test(String(line || "").trim());

const isStructuredPlannerParts = (parts) => {
  const label = String(parts?.label || "").trim();
  const value = String(parts?.value || "").trim();
  if (!label || !value) return false;
  return STRUCTURED_PLANNER_LABEL_RE.test(label);
};

const looksLikeKeyValue = (line) => {
  const parts = getKeyValueParts(line);
  if (!parts) return false;
  if (parts.label.length > 48) return false;
  return true;
};

const getKeyValueParts = (line) => {
  const text = String(line || "").trim();
  if (!text) return null;

  const [leadLine, ...restLines] = text.split("\n");
  const leadMatch = leadLine.match(/^([^:]{1,64}):\s+(.+)$/);
  if (!leadMatch) return null;

  const left = String(leadMatch[1] || "").trim().replace(/\s+/g, " ");
  let right = String(leadMatch[2] || "").trim();
  if (!SAFE_KEY_VALUE_LABEL_RE.test(left)) return null;
  if (/\d$/.test(left)) return null;
  const continuation = restLines.map((entry) => String(entry || "").trim()).filter(Boolean);
  if (continuation.length > 0) {
    right = right ? `${right}\n${continuation.join("\n")}` : continuation.join("\n");
  }
  if (!left || !right) return null;
  return { label: left, value: right };
};

const shouldUseStructuredPlannerRow = (parts) => {
  return isStructuredPlannerParts(parts);
};

const normalizeSectionTitle = (line) => {
  const text = String(line || "").trim();

  if (/^x\s*\(twitter\)$/i.test(text)) return "X (Twitter)";
  if (/^ctv$/i.test(text)) return "Connected TV (CTV)";
  if (/^olv$/i.test(text)) return "Online Video (OLV)";
  if (/^dooh$/i.test(text)) return "Digital-Out-of-Home (DOOH)";
  if (/^cinema$/i.test(text)) return "Cinema (Theatrical)";
  if (/^google search$/i.test(text)) return "Google Search";

  return text;
};

const looksLikeSectionTitle = (line) => {
  const text = String(line || "").trim();
  if (!text) return false;
  if (text.length > 80) return false;

  const known =
    /^(youtube|facebook|instagram|tiktok|shopify|linkedin(\s+ads)?|x(\s*\(twitter\))?|ctv|connected tv|olv|display|dooh|cinema|theatrical|google search|search|meta|platform roles|retargeting \+ audience expansion|optimization focus|high[-\s]?performing levers|strategic takeaway|final summary|overall ad spend|final performance overview \+ insights|budget allocation by platform|flighting & phasing|audience & targeting|creative guidance|optimization logic & guardrails|insights|campaign notes|campaign strategy|progress assessment)$/i;

  if (known.test(text)) return true;
  if (/^[A-E]\.\s+.{3,80}$/i.test(text)) return true;
  if (text.length <= 56 && /^[A-Za-z0-9][A-Za-z0-9 &/()+–—-]*$/.test(text)) return true;

  return false;
};

const looksLikeSubhead = (line) => {
  const text = String(line || "").trim();
  if (!text) return false;
  if (/^(insight|summary|takeaway|learnings)\s*:$/i.test(text)) return true;
  if (/^(\d+[.)]|[IVX]+\.)\s+/.test(text)) return true;
  if (/^(rationale|objective|guardrails|notes|recommendation)\b/i.test(text)) return true;
  if (/:$/.test(text) && text.length <= 90) return true;
  return false;
};

const isCanonicalTriggeredHeroHeading = (line, hero) => {
  if (!hero) return false;
  const trimmed = String(line || "").trim();
  const withoutPrefix = stripPrefixSymbols(trimmed);
  const normalized = normalizeSectionTitle(withoutPrefix);
  if (normalized.toLowerCase() === hero.label.toLowerCase()) return true;

  const qualifierMatch = normalized.match(/^(.+?)\s*[:\-–—]\s*([^.!?]{1,36})$/);
  return (
    Boolean(qualifierMatch) &&
    String(qualifierMatch[1] || "").trim().toLowerCase() === hero.label.toLowerCase()
  );
};

export const getExplicitHeroForLine = (line) => {
  const trimmed = String(line || "").trim();
  const match = trimmed.match(/^\s*(📘|📸|🎵|📺|🔎|🎬|💻|🎞️|🐦)\s+/u);
  if (!match) return null;
  const hero = EXPLICIT_CHANNEL_HERO_BY_TRIGGER[match[1]] || null;
  return isCanonicalTriggeredHeroHeading(trimmed, hero) ? hero : null;
};

function defaultResolveHero(line) {
  return getExplicitHeroForLine(line);
}

const HERO_DETAIL_SEPARATOR_RE = /^(.+?)\s*[:\-–—]\s*(.+)$/;
const HERO_DETAIL_VALUE_RE = /^(.+?)\s+((?:~|\$|\d|\(|<|>|%).+)$/;
const COMBINED_PROGRAMMATIC_HEADING_RE =
  /^(?:programmatic\s+)?(?:video(?:\s*\(olv\))?|olv|online video)(?:\s*(?:&|and)\s*)(?:programmatic\s+)?display$/i;

function getCombinedProgrammaticHeroes(rawLine) {
  const raw = String(rawLine || "").trim();
  if (!raw) return null;

  const withoutPrefix = stripPrefixSymbols(raw);
  const clean = stripEmojiLike(withoutPrefix);
  if (!clean) return null;

  const separatorMatch = clean.match(HERO_DETAIL_SEPARATOR_RE);
  const headingSource = separatorMatch ? String(separatorMatch[1] || "").trim() : clean;
  const detail = separatorMatch ? String(separatorMatch[2] || "").trim() : "";
  const normalizedHeading = normalizeSectionTitle(headingSource);

  if (!COMBINED_PROGRAMMATIC_HEADING_RE.test(normalizedHeading)) return null;

  return {
    heroes: [CHANNEL_HERO_MAP.olv, CHANNEL_HERO_MAP.display].filter(Boolean),
    detail,
  };
}

function extractHeroLead(rawLine, resolveHero) {
  if (typeof resolveHero !== "function") return null;

  const raw = String(rawLine || "").trim();
  if (!raw) return null;

  const withoutPrefix = stripPrefixSymbols(raw);
  const clean = stripEmojiLike(withoutPrefix);
  if (!clean) return null;

  const hero = resolveHero(raw) || resolveHero(clean);
  if (!hero) return null;

  const separatorMatch = clean.match(HERO_DETAIL_SEPARATOR_RE);
  if (separatorMatch) {
    return { hero, clean, detail: String(separatorMatch[2] || "").trim() };
  }

  const valueLeadMatch = clean.match(HERO_DETAIL_VALUE_RE);
  if (valueLeadMatch) {
    return { hero, clean, detail: String(valueLeadMatch[2] || "").trim() };
  }

  return { hero, clean, detail: "" };
}

function renderHero(prefix, hero, key) {
  const image = hero?.img || hero?.logo;
  if (!hero || !image) return null;

  return (
    <div key={key} className={`${prefix}-section-hero`}>
      <img
        src={image}
        alt={`${hero.label} logo`}
        className={`${prefix}-section-hero-img`}
        loading="lazy"
        draggable={false}
      />
      <div className={`${prefix}-section-hero-title`}>
        {normalizeSectionTitle(hero.label)}
      </div>
    </div>
  );
}

const normalizeHeroAllowKey = (value) => {
  const compact = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/([a-z])([A-Z])/g, "$1$2")
    .replace(/[^a-z0-9]/g, "");

  if (
    compact === "programmaticolv" ||
    compact === "programmaticvideo" ||
    compact === "onlinevideo" ||
    compact === "olv"
  ) {
    return "video";
  }

  if (
    compact === "googlesearch" ||
    compact === "googlepaidsearch" ||
    compact === "paidsearch" ||
    compact === "search"
  ) {
    return "google_search";
  }

  if (compact === "truthsocial") return "truth_social";
  if (compact === "ingame" || compact === "ingames") return "ingame";
  if (
    compact === "dooh" ||
    compact === "digitaloutofhome" ||
    compact === "ooh"
  ) {
    return "dooh";
  }

  return compact;
};

const isHeroAllowed = (hero, allowedHeroKeys) => {
  if (!allowedHeroKeys) return true;
  const key = normalizeHeroAllowKey(hero?.key || hero?.label);
  return key ? allowedHeroKeys.has(key) : true;
};

const inferHeroKeyFromLine = (line) => {
  const clean = stripEmojiLike(stripPrefixSymbols(line)).toLowerCase();
  if (!clean) return "";

  if (COMBINED_PROGRAMMATIC_HEADING_RE.test(normalizeSectionTitle(clean))) return "";
  if (clean.startsWith("google search") || (clean.startsWith("google") && clean.includes("search"))) {
    return "google_search";
  }
  if ((clean.includes("youtube") || clean.includes("you tube")) && !clean.includes("search")) {
    return "youtube";
  }
  if (
    clean.startsWith("programmatic video") ||
    clean.startsWith("programmatic olv") ||
    clean.startsWith("online video") ||
    clean.startsWith("olv") ||
    clean.startsWith("video")
  ) {
    return "video";
  }
  if (clean.startsWith("tiktok")) return "tiktok";
  if (clean.startsWith("facebook")) return "facebook";
  if (clean.startsWith("instagram")) return "instagram";
  if (clean === "x" || clean.startsWith("x ") || clean.startsWith("twitter")) return "x";
  if (clean.startsWith("reddit")) return "reddit";
  if (clean.startsWith("amazon")) return "amazon";
  if (clean.startsWith("shopify")) return "shopify";
  if (clean.startsWith("linkedin") || clean.startsWith("linked in")) return "linkedin";
  if (clean.startsWith("rumble")) return "rumble";
  if (clean.startsWith("truth social")) return "truth_social";
  if (
    clean.startsWith("ctv") ||
    clean.startsWith("connected tv") ||
    clean.startsWith("connected television")
  ) {
    return "ctv";
  }
  if (clean.startsWith("display")) return "display";
  if (clean.startsWith("mobile")) return "mobile";
  if (clean.startsWith("audio")) return "audio";
  if (clean.startsWith("in-game") || clean.startsWith("ingame")) return "ingame";
  if (
    clean.startsWith("dooh") ||
    clean.startsWith("digital out of home") ||
    clean.startsWith("digital out-of-home") ||
    clean === "ooh" ||
    clean.startsWith("ooh ")
  ) {
    return "dooh";
  }
  if (clean.startsWith("email")) return "email";
  if (clean.startsWith("meta")) return "meta";
  return "";
};

const isAllowedPlatformHeading = (line, allowedHeroKeys) => {
  if (!allowedHeroKeys) return true;
  const key = inferHeroKeyFromLine(line);
  return key ? allowedHeroKeys.has(normalizeHeroAllowKey(key)) : true;
};

function renderStackedKeyValue(prefix, label, value, key, withBullet = false) {
  const className = withBullet
    ? `${prefix}-rich-line ${prefix}-rich-bullet ${prefix}-rich-kvstack`
    : `${prefix}-rich-line ${prefix}-rich-kvstack`;

  return (
    <div key={key} className={className}>
      {withBullet ? (
        <span className={`${prefix}-rich-bullet-dot`}>{STANDARD_BULLET_MARKER}</span>
      ) : null}
      <span className={`${prefix}-rich-text`}>
        <span className={`${prefix}-rich-kvstack-label`}>{label}:</span>
        <span className={`${prefix}-rich-kvstack-value`}>{value}</span>
      </span>
    </div>
  );
}

function renderStructuredKeyValue(prefix, label, value, key) {
  return renderStackedKeyValue(
    prefix,
    label,
    value,
    key,
    true
  );
}

function normalizeStrategyLines(rawLines) {
  const normalized = [];

  for (let index = 0; index < rawLines.length; index += 1) {
    const current = String(rawLines[index] ?? "");
    const trimmed = current.trim();

    if (ORPHAN_BULLET_RE.test(trimmed)) {
      const next = String(rawLines[index + 1] ?? "").trim();
      if (next) {
        normalized.push(`${STANDARD_BULLET_MARKER} ${next}`);
        index += 1;
        continue;
      }
    }

    normalized.push(current);
  }

  const merged = [];

  for (let index = 0; index < normalized.length; index += 1) {
    const current = String(normalized[index] ?? "");
    const trimmed = current.trim();

    if (!trimmed) {
      merged.push(current);
      continue;
    }

    const sourceForKeyValue = BULLET_PREFIX_RE.test(trimmed)
      ? stripEmojiLike(stripPrefixSymbols(trimmed))
      : trimmed;
    const parts = getKeyValueParts(sourceForKeyValue);

    if (!parts || (BULLET_PREFIX_RE.test(trimmed) && !isStructuredPlannerParts(parts))) {
      merged.push(current);
      continue;
    }

    let combined = current;
    let nextIndex = index + 1;

    while (nextIndex < normalized.length) {
      const candidate = String(normalized[nextIndex] ?? "");
      const candidateTrimmed = candidate.trim();
      if (!candidateTrimmed) break;
      if (ORPHAN_BULLET_RE.test(candidateTrimmed)) break;
      if (BULLET_PREFIX_RE.test(candidateTrimmed)) break;
      if (SECTION_ICON_PREFIX_RE.test(candidateTrimmed)) break;
      if (isDividerLine(candidateTrimmed)) break;

      const candidateClean = stripEmojiLike(stripPrefixSymbols(candidateTrimmed));
      if (looksLikeSectionTitle(candidateClean)) break;
      if (looksLikeSubhead(candidateClean)) break;
      if (looksLikeKeyValue(candidateClean)) break;

      combined = `${combined}\n${candidateTrimmed}`;
      nextIndex += 1;
    }

    merged.push(combined);
    index = nextIndex - 1;
  }

  return merged;
}

export default function CphereAnalysisWriteup({
  text,
  prefix = "cphere-analysis",
  emptyMessage = "No insights yet…",
  resolveHero = defaultResolveHero,
  heroOnPlainHeaders = false,
  allowedHeroKeys = null,
}) {
  const raw = normalizeText(text);
  const content = clampText(raw, 26000).trim();

  if (!content) {
    return (
      <div className={`${prefix}-rich-output`}>
        <div className={`${prefix}-rich-empty`}>{emptyMessage}</div>
      </div>
    );
  }

  const lines = normalizeStrategyLines(splitSmartLines(content));
  const nodes = [];
  let lastHeroKey = null;
  const normalizedAllowedHeroKeys = Array.isArray(allowedHeroKeys)
    ? new Set(allowedHeroKeys.map(normalizeHeroAllowKey).filter(Boolean))
    : null;

  for (let index = 0; index < lines.length; index += 1) {
    const original = String(lines[index] ?? "");
    const trimmed = original.trim();

    if (!trimmed) {
      nodes.push(<div key={`sp-${index}`} className={`${prefix}-rich-spacer`} />);
      continue;
    }

    if (isDividerLine(trimmed)) {
      nodes.push(<div key={`dv-${index}`} className={`${prefix}-rich-divider`} />);
      continue;
    }

    if (!isAllowedPlatformHeading(trimmed, normalizedAllowedHeroKeys)) {
      continue;
    }

    const combinedProgrammatic = getCombinedProgrammaticHeroes(trimmed);
    if (combinedProgrammatic?.heroes?.length) {
      const allowedCombinedHeroes = combinedProgrammatic.heroes.filter((hero) =>
        isHeroAllowed(hero, normalizedAllowedHeroKeys)
      );
      for (let heroIndex = 0; heroIndex < allowedCombinedHeroes.length; heroIndex += 1) {
        const hero = allowedCombinedHeroes[heroIndex];
        const promotedHeroKey = hero?.key || hero?.label || `hero-${index}-${heroIndex}`;
        if (promotedHeroKey === lastHeroKey) continue;

        nodes.push(
          renderHero(prefix, hero, `hero-combined-${promotedHeroKey}-${index}-${heroIndex}`)
        );
        lastHeroKey = promotedHeroKey;
      }

      if (allowedCombinedHeroes.length > 0 && combinedProgrammatic.detail) {
        nodes.push(
          <div
            key={`hero-combined-detail-${index}`}
            className={`${prefix}-rich-line ${prefix}-rich-hero-detail`}
          >
            {combinedProgrammatic.detail}
          </div>
        );
      }
      continue;
    }

    const heroLead = extractHeroLead(trimmed, resolveHero);

    if (BULLET_PREFIX_RE.test(trimmed)) {
      const withoutPrefix = stripPrefixSymbols(trimmed);
      const clean = stripEmojiLike(withoutPrefix);

      if (heroLead?.hero && heroLead?.detail) {
        const promotedHeroKey =
          heroLead.hero?.key || heroLead.hero?.label || `hero-${index}`;

        if (promotedHeroKey !== lastHeroKey) {
          nodes.push(
            renderHero(prefix, heroLead.hero, `hero-bullet-${promotedHeroKey}-${index}`)
          );
          lastHeroKey = promotedHeroKey;
        }

        nodes.push(
          <div
            key={`hd-b-${index}`}
            className={`${prefix}-rich-line ${prefix}-rich-hero-detail`}
          >
            {heroLead.detail}
          </div>
        );
        continue;
      }

      if (looksLikeKeyValue(clean)) {
        const parts = getKeyValueParts(clean);
        if (!parts) continue;
        const { label, value } = parts;

        if (shouldUseStructuredPlannerRow(parts)) {
          nodes.push(
            renderStructuredKeyValue(prefix, label, value, `bkv-structured-${index}`)
          );
          continue;
        }
      }

      nodes.push(
        <div
          key={`b-${index}`}
          className={`${prefix}-rich-line ${prefix}-rich-bullet`}
        >
          <span className={`${prefix}-rich-bullet-dot`}>{STANDARD_BULLET_MARKER}</span>
          <span className={`${prefix}-rich-text`}>{clean}</span>
        </div>
      );
      continue;
    }

    const maybeStripped = stripPrefixSymbols(trimmed);
    const cleanForTitle = stripEmojiLike(maybeStripped);
    const hasSectionPrefix = SECTION_ICON_PREFIX_RE.test(trimmed);
    const resolvedHero = typeof resolveHero === "function" ? resolveHero(trimmed) : null;
    const heroImage = resolvedHero?.img || resolvedHero?.logo;
    const heroKey = resolvedHero?.key || resolvedHero?.label || "";
    const canUsePlainHeaderHero =
      heroOnPlainHeaders && Boolean(heroImage) && looksLikeSectionTitle(cleanForTitle);

    if (hasSectionPrefix || canUsePlainHeaderHero) {
      if (heroImage && heroKey !== lastHeroKey) {
        nodes.push(
          renderHero(prefix, resolvedHero, `hero-${heroKey || index}-${index}`)
        );
        lastHeroKey = heroKey;
        continue;
      }

      nodes.push(
        <div key={`h1-pref-${index}`} className={`${prefix}-rich-h1`}>
          {normalizeSectionTitle(cleanForTitle)}
        </div>
      );
      continue;
    }

    if (heroLead?.hero && heroLead?.detail) {
      const promotedHeroKey =
        heroLead.hero?.key || heroLead.hero?.label || `hero-${index}`;

      if (promotedHeroKey !== lastHeroKey) {
        nodes.push(
          renderHero(prefix, heroLead.hero, `hero-inline-${promotedHeroKey}-${index}`)
        );
        lastHeroKey = promotedHeroKey;
      }

      nodes.push(
        <div
          key={`hd-${index}`}
          className={`${prefix}-rich-line ${prefix}-rich-hero-detail`}
        >
          {heroLead.detail}
        </div>
      );
      continue;
    }

    if (looksLikeSectionTitle(cleanForTitle)) {
      nodes.push(
        <div key={`h1-${index}`} className={`${prefix}-rich-h1`}>
          {normalizeSectionTitle(cleanForTitle)}
        </div>
      );
      continue;
    }

    if (looksLikeSubhead(cleanForTitle)) {
      nodes.push(
        <div key={`h2-${index}`} className={`${prefix}-rich-h2`}>
          {cleanForTitle}
        </div>
      );
      continue;
    }

    if (looksLikeKeyValue(cleanForTitle)) {
      const parts = getKeyValueParts(cleanForTitle);
      if (!parts) continue;
      const { label, value } = parts;

      if (shouldUseStructuredPlannerRow(parts)) {
        nodes.push(
          renderStructuredKeyValue(prefix, label, value, `kv-structured-${index}`)
        );
        continue;
      }

      nodes.push(
        <div key={`kv-${index}`} className={`${prefix}-rich-line ${prefix}-rich-kvline`}>
          <span className={`${prefix}-rich-k`}>{label}:</span>{" "}
          <span className={`${prefix}-rich-v`}>{value}</span>
        </div>
      );
      continue;
    }

    nodes.push(
      <div key={`l-${index}`} className={`${prefix}-rich-line`}>
        {cleanForTitle}
      </div>
    );
  }

  return (
    <div className={`${prefix}-rich-output`}>
      <div className={`${prefix}-rich-block`}>{nodes}</div>
    </div>
  );
}
